import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../../../models/https';
import { notificationsActions } from '../../../../redux/slices/notificationsSlice';
import { useAppDisPatch } from '../../../../redux/store';
import useHttps from '../../../useHttps';

const useDeleteNotice = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onDeleteNoticeError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while deleting notification'
    );
  };

  const onDeleteNoticeSuccess = useCallback(
    (_response: any, notificationId: string) => {
      // Dispatch action to remove the notification from Redux
      dispatch(notificationsActions.removeNotification(notificationId));
    },
    [dispatch]
  );

  const deleteNotice = useCallback(
    (notificationId: string) => {
      const urlPath = `notifications/${notificationId}`;
      const url: HttpConfig = {
        url: urlPath,
        method: 'delete',
      };

      return request(
        url,
        (response: any) => onDeleteNoticeSuccess(response, notificationId),
        setLoading,
        onDeleteNoticeError
      );
    },
    [request, onDeleteNoticeSuccess]
  );

  return { deleteNotice, loading };
};

export default useDeleteNotice;
